// extracted by mini-css-extract-plugin
export default {"root":"PoR_root__8DbGr","content":"PoR_content__WsGDu"};